 <template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >
    <slot name="before"></slot>
    <!-- https://buefy.org/documentation/input  -->
    <b-input
      v-bind="$attrs"
      :value="value"
      :id="forId"
      :type="type"
      :size="size"
      expanded
      :placeholder="placeholder"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    ></b-input>
    <slot name="after"></slot>
  </form-field>
</template>

<script>
  import FormField from "./FormField";
  import {FormFieldMixin} from "./FormField.mixin";
  import utils from "../../services/utils";

  export default {
    name: "FormFieldInput",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {},
      placeholder: {
        type: String
      },
      label: {
        type: String,
      },
      validationErrors: {
        type: [String, Array, undefined],
      },
      helpText: {
        type: String
      },
      type: {
        type: String,
        default: 'text'
      },
      size: {
        type: String,
        default: 'is-small'
      },
      inputId: {
        type: String,
      },
      debounce: {
        type: Function,
        required: false
      },
      debounceTimeout: {
        type: Number,
        required: false,
        default: 500
      },
    },
    data() {
      return {
        forId: this.inputId ? this.inputId : this.$utils.generateClientId(),
        debounceRef: undefined,
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();

        if (this.debounce) {
          this.debounceRef = utils.debounce(this.debounce, this.debounceRef, this.debounceTimeout)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles
</style>
